export default "__VITE_ASSET__BygZ$cQE__"